const style = {
  quoteWrapper: {
    background: "#F9F9FF",
    overflow: "auto",
    // Fill the flex <main> beside the oads-sidebar and own the scroll (both axes),
    // instead of a fixed 100vh that ignored the topbar and let the 1200px quote
    // pages overflow the page horizontally.
    flex: "1 1 auto",
    minHeight: 0,
    minWidth: 0,
    "&::-webkit-scrollbar": {
      width: 0,
    },

    "@media (max-width: 768px)": {
      overflow: "unset",
    },
  },
  mainWrapper: {
    width: "fit-content",
    minWidth: "100%",
    height: "fit-content",
    display: "flex",
    justifyContent: "center",
    padding: "0 32px",
  },
  pagesWrapper: {
    marginTop: "16px",
    height: "100%",
    // Was a fixed 1200px (two 592px print pages side-by-side). Beside the
    // oads-sidebar the content area is narrower, so allow the two fixed-size
    // pages to wrap/stack and center instead of overflowing/clipping. Print is
    // unaffected (it clones the fixed-size page refs into its own container).
    width: "100%",
    maxWidth: "1200px",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: "center",
  },
  page: {
    width: "592px",
    minHeight: "678px",
    background: "#FFFFFF",
    padding: "16px 16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "default",
  },
  title: {
    fontWeight: "700",
    fontSize: "28px",
    lineHeight: "34px",
    display: "flex",
    alignItems: "center",
    color: "#011533",
    marginBottom: "12px",
  },
  containerSubmitterPrint: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  text: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    color: "#011533",
    wordBreak: "break-word",
  },
  row: {
    display: "flex",
    marginBottom: "4px",
    "& > div": {
      flex: 1,
    },
  },
  link: {
    color: "#EE4360",
    textDecorationLine: "underline",
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "18px",
    cursor: "pointer",
  },
  noFile: {
    color: "#AEAFC7",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  couponCodeLink: {
    color: "#4F5B94",
    paddingRight: "20px",
  },
  couponCodeWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "12px",
  },
  line: {
    border: "1px solid #E2E2FC",
    marginTop: "24px",
    marginBottom: "24px",
    width: "100%",
  },
  underline: {
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    textDecorationLine: "underline",
    color: "#0B2456",
    marginLeft: "8px",
  },
  printWrap: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "48px",
    marginRight: "16px",
    "& > div": {
      display: "flex",
      cursor: "pointer",
    },
  },
  editAudience: {
    cursor: "pointer",
    color: "#EE4360",
    textDecorationLine: "underline",
    fontWeight: "700",
  },
  scroll: {
    overflowY: "scroll",
    maxHeight: "114px",
    marginRight: "-5px",
  },
  flex: {
    display: "flex",
  },
  flex_1: {
    flex: "1",
  },
  flex_1_5: {
    flex: "1.5",
  },
  lastRows: {
    flex: "3.5",
    "& span": {
      marginLeft: "241px",
    },
  },

  cityRow: {
    marginBottom: "8px",
  },
  bold: {
    fontWeight: "700",
  },
  marginBottom_4: {
    marginBottom: "4px",
  },
  quote: {
    marginLeft: "16px",
    marginBottom: "4px",
    lineHeight: "24px",
  },
  detailsProvided: {
    marginBottom: "12px",
  },
  campaignName: {
    marginRight: "40px",
  },
  center: {
    alignItems: "center",
    textAlign: "center",
  },
  table: {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
  },
  tableRow: {
    borderBottom: "1px solid #E2E2FC",
    display: "flex",
    "& > div": {
      marginTop: "10px",
      marginBottom: "10px",
    },
  },
  grandTotalWrapper: {
    width: "auto",
    marginLeft: "auto",
    marginTop: "24px",
    "& > div:first-child": {
      flex: "1.5",
    },
  },
  grandTotalSubContainer_1: {
    display: "flex",
    flexDirection: "column",
    flex: "2 !important",
    background: "#F9F9FF",
    padding: "12px 15px",
    alignItems: "flex-end",
  },
  grandTotalSubContainer_2: {
    display: "flex",
  },
  taxText: {
    fontSize: 12,
    color: "#011533",
    paddingTop: "4px",
  },
  salesTaxesWarn: {
    fontSize: 12,
    color: "#EE4360",
    marginLeft: "241px",
    marginBottom: "10px",
  },
  grandTotal: {
    borderRadius: "4px 0px 0px 4px",
  },
  grandTotalCost: {
    width: "124px",
    textAlign: "center",
  },
  bookingFooterWrapper: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 0,
  },
  buttonsWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  buttonsWrapperOld: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    marginTop: "16px",
  },
  button: {
    position: "relative",
    background: "#EE4360",
    borderRadius: "16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "208px",
    height: "48px",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  buttonText: {
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#FFFFFF",
  },
  disabled: {
    background: "#C2C8D1",
    "&:hover": {
      transform: "none",
    },
  },
  progress: {
    position: "absolute",
    top: "14px",
    left: "30px",
    color: "#FFFFFF",
  },
  marginL4: {
    marginLeft: "4px",
  },
  skipContainer: {
    width: "100%",
    height: "75px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FFE7EB",
    borderRadius: "4px",
    marginTop: "10px",
    padding: "15px",
    marginBottom: "60px",
    "@media screen and (max-width: 450px)": {
      height: "150px",
    },
  },
  skipContentBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    "@media screen and (max-width: 450px)": {
      position: "relative",
    },
  },
  skipTitleContainer: {
    width: "inherit",
    display: "flex",
    height: "35px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flyerTitleSkip: {
    color: "#E00404",
    fontSize: "14px",
    fontWeight: "600",
    marginLeft: "5px",
  },
  iconWithTitle: {
    display: "flex",
    width: "inherit",
    height: "inherit",
    alignItems: "center",
    "@media screen and (max-width: 450px)": {
      position: "absolute",
      top: -50,
    },
  },
  uploadFlyerButton: {
    textAlign: "center",
    height: "30px",
    color: "#D72B4F",
    border: "1px solid #D72B4F",
    borderRadius: "8px",
    width: "150px",
    fontSize: "13px",
    fontWeight: "700",
    cursor: "pointer",
    "@media screen and (max-width: 450px)": {
      position: "absolute",
      bottom: -40,
    },
  },
  skipText: {
    maxWidth: "75%",
    fontSize: "13px",
    "@media screen and (max-width: 450px)": {
      position: "absolute",
      top: -10,
      maxWidth: "100%",
    },
  },
  usTaxDisclaimer: {
    color: "#798498",
    fontSize: "14px",
    fontStyle: "italic",
    fontWeight: "400",
    lineHeight: "24px",
    marginLeft: "auto",
    marginBottom: "24px",
  },
  default: {
    color: "#AEAFC7",
    fontSize: "16px",
    marginLeft: "4px",
  },
};

export { style };
